<template>
  <v-app :class="this.themeId" class="rttApp" light>
    <v-main>
      <ThemeElementSlot name="Background" />
      <AlertComponent v-if="!message.modal" />
      <router-view class="widget-container"></router-view>
      <ThemeElementSlot name="SubContent" />
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'pinia';
import AlertComponent from '../../components/AlertComponent';
import ThemeElementSlot from '@/components/ThemeElementSlot';
import { useThemeStore } from '@/stores/theme.js';
import { useTrackingDataStore } from '@/stores/trackingData.js';
import { useAlertStore } from '@/stores/alert.js';

export default {
  name: 'App',
  components: {
    AlertComponent,
    ThemeElementSlot
  },
  computed: {
    ...mapState(useAlertStore, ['message']),
    ...mapState(useTrackingDataStore, {
      trackingData: 'data'
    }),
    ...mapState(useThemeStore, ['themeId'])
  }
};
</script>

<style scoped>
.widget-container {
  padding: 0.5em;
}
</style>
